module.exports = __webpack_public_path__ + "static/media/info-icon.76209537.svg";